<template>
  <mdb-container>
    <div style="padding-top: 125px;"></div>
    <mdb-card class="mb-4 text-left">
      <mdb-card-header class="secondary-color">
        <div>
          <mdb-btn @click="$router.push('/topics')" rounded size="sm" icon="arrow-left">
            Topics List
          </mdb-btn>
        </div>
        <div>
          <h4>Topic: {{topicName}}</h4>
        </div>
      </mdb-card-header>
      <mdb-card-body class="mb-4">
        <mdb-row v-if="groups.length>0">
          <div :key="i" class="col-md-3 d-flex align-self-stretch" v-for="(g,i) in groups">
            <a @click="$router.push(g.url)" href="">
              <mdb-card class="face front mb-4 animated slideInLeft">
                <mdb-card-header class="text-right">
                  <mdb-badge>{{g.members}} {{g.memberLabel}}</mdb-badge>
                </mdb-card-header>
                <mdb-view hover zoom>
                  <mdb-card-image
                    :src="g.avatar"
                    alt="Card image cap"
                  ></mdb-card-image>
                  <mdb-mask flex-center overlay="white-slight" waves></mdb-mask>

                </mdb-view>
                <mdb-card-body>
                  <div>{{g.name}}</div>
                  <div>{{g.city ? g.city : '&nbsp; '}}</div>
                  <div>{{g.country && g.country != g.city ? g.country : '&nbsp; '}}</div>

                </mdb-card-body>
              </mdb-card>
            </a>
          </div>
        </mdb-row>
      </mdb-card-body>

    </mdb-card>
  </mdb-container>
</template>

<script>
import api from '../services/groupsPlaceApi.js'
import groupCard from './group/Card'
import {
  mdbBadge,
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardGroup,
  mdbCardHeader,
  mdbCardImage,
  mdbCardText,
  mdbCardTitle,
  mdbCol,
  mdbContainer,
  mdbInput,
  mdbMask,
  mdbModal,
  mdbModalBody,
  mdbModalHeader,
  mdbRow,
  mdbView,
} from 'mdbvue';

export default {
    name: 'Explore',
    components: {
      mdbContainer,
      mdbCard,
      mdbCardHeader,
      mdbCardGroup,
      mdbCardBody,
      mdbCardTitle,
      mdbCardText,
      mdbRow,
      mdbCol,
      mdbMask,
      mdbCardImage,
      mdbView,
      mdbBadge,
      mdbBtn,
      mdbModal,
      mdbModalHeader,
      mdbModalBody,
      mdbInput,
      groupCard
    },
    data() {
      return {
        groups: [],
        topicName: ""
      }
    },
    mounted() {
      this.loadData()
    },
    methods: {
      showTopic(t) {
        alert(t)
      },
      loadData() {
        this.$store.dispatch("setExecuting", false)
        let url = "/public/topicShow/" + this.$route.params.uri
        api.get(url).then(
          (results) => {

            this.topicName = results.data.topicName
            this.groups = results.data.groups
          },
          (error) => {
            this.$notify.error({message: "Error fetching page.", timeOut: 5000})
          }).then(() => {
          this.$store.dispatch("setExecuting", false)
        })

      }
    }

  };
</script>
<style scoped>

</style>
